export const MAX_LICENSE_COUNT = 5000000; // 5M. Agreed to have this number as Max for now.
